import {
    Input,
    notify,
    UploadFile,
    SelectOption, CitySelect, InputError, ShowInfo, ProgressBar
} from '../../utils';
import { FormProvider, useForm } from 'react-hook-form';
import { TextArea } from '../../utils/TextArea';
import {useEffect, useState} from 'react';
import {cancelTransaction, companyInfoComplete, getCompanyInfo} from '../../../api/MoadianService';
import { Toaster } from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import {Box, Dialog, DialogContent, TextField} from "@mui/material";
import {nextStep, prevStep} from '../../redux/actions/StepperAction';
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import {useNavigate} from "react-router-dom";

export default function CompanyInfoRejected({transactionStatus}) {

    const [isSubmitted, setIsSubmitted] = useState(false)
    const [openModal, setOpenModal] = useState(false)
    const [isModalLoading, setIsModalLoading] = useState(false)
    const [companyInfo, setCompanyInfo] = useState('')
    const [companyInfoError, setCompanyInfoError] = useState('')
    const tokenInfo = useSelector(state => state.Token)
    const [accountNumber, setAccountNumber] = useState('')
    const [accountNumberError, setAccountNumberError] = useState(false)
    const [shebaNumber, setShebaNumber] = useState('')
    const [shebaNumberError, setShebaNumberError] = useState(false)
    const [cancelReason, setCancelReason] = useState('');
    const [disable, setDisable] = useState(true);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const methods = useForm({
        defaultValues: companyInfo
    });
    let index = 1;

    const formData = new FormData();

    useEffect(() => {

        if(transactionStatus == 'REJECTED') {
            setDisable(false)
        }

        getCompanyInfo(tokenInfo.transactionId).then(response => {

            methods.reset(response.data.companyInfo);
            methods.setValue("province", {
                label: response?.data?.companyInfo?.province ?? "",
                value: response?.data?.companyInfo?.province ?? ""
            });
            methods.setValue("city", {
                label: response?.data?.companyInfo?.city ?? "",
                value: response?.data?.companyInfo?.city ?? ""
            });
            methods.setValue("companyType", {
                label: response.data.companyInfo?.companyType == "Governmental" ? "دولتی" : "غیر دولتی",
                value: response.data.companyInfo?.companyType ?? ""
            })
            setCompanyInfo(response.data.companyInfo);
            setCompanyInfoError(response.data.companyErrorInfo)
        }).catch(error => {
            notify(error.response.data.message);
        })

    }, [])

    const onSubmit = methods.handleSubmit(data => {

        if(!disable){
            setIsSubmitted(true)
            const dataToSend = {
                ...data,
                province: data.province.value,
                city: data.city.value,
                companyType: data.companyType.value
            }


            Object.keys(dataToSend).forEach((key) => {
                if(
                    key != 'establishedNewspaperImage' &&
                    key != 'introductionLetterImage' &&
                    key != 'latestOfficialNewspaperImage' &&
                    key != 'managerNationalCardImage'
                ) {
                    formData.append(key, dataToSend[key])
                }else{
                    if(!formData.get(key)){
                        formData.append(key, dataToSend[key])
                    }
                }
            });

            companyInfoComplete(tokenInfo.transactionId, formData).then(response => {
                setIsSubmitted(false)
                navigate('/company/list')

            }).catch(
                error => {
                    setIsSubmitted(false)
                    notify(error.response.data.message)
                }
            )
        }else{
            dispatch(nextStep());
        }


    })

    const handleCancel = () => {
        setIsModalLoading(true)

        if(shebaNumber.length != 24){
            setShebaNumberError(true)
            setIsModalLoading(false)
        }

        if(accountNumber.length != 16) {
            setAccountNumberError(true)
            setIsModalLoading(false)
        }

        if( shebaNumber.length == 24 && accountNumber.length == 16 ) {
            const accountData = {
                accountNumber: accountNumber,
                shebaNumber: shebaNumber,
                cancelReason: cancelReason,
            }

            cancelTransaction(tokenInfo.transactionId, accountData).then(response => {

                setIsModalLoading(false)
                setOpenModal(false)
                navigate('/company/list')

            }).catch(error => {
                notify(error.response.data.message)
                setIsModalLoading(false)
            })
        }


    }

    return (
        <div>
            <Toaster/>
            <ShowInfo
                title={'تکمیل اطلاعات شرکت'}
                message={'لطفا اطلاعات مربوط به شرکت را با دقت وارد نمایید.'}
            />

            {!disable && <div className='container my-4'>

                <div className='row justify-content-center  mt-3'>
                    <div className='col-12 col-md-5 border' style={{"borderRadius": "10px", background: "#fff3f3"}}>

                        <>
                            <p className='complete-info-text my-2' style={{color: "#58152d"}}>اطلاعات شما تایید نشده است</p>

                            {companyInfoError &&
                                Object.keys(companyInfoError).map(function (keyName, keyIndex) {
                                    if (keyName != 'id' && companyInfoError[keyName]) {
                                        return (
                                            <div key={keyIndex} className='complete-info-text-row py-2'  style={{color: "#58152d"}}>
                                                {index++} - {companyInfoError[keyName]}
                                            </div>
                                        )
                                    }
                                })
                            }

                        </>

                    </div>
                </div>
            </div>}


            <Dialog open={openModal}>
                <DialogContent>
                    <Grid2 justifyContent="center" spacing={1}>
                        <Grid2 xs={12} lg={7}>
                            <p className=" show-info-title me-1 my-0 me-lg-2 p-0 ">انصراف</p>
                            <p className="show-info-text me-1 me-lg-2 my-0 p-0 ">در صورت انصراف مبلغی از پرداخت شما کسر شده و مابقی آن به حساب شما واریز می‌شود.</p>

                        </Grid2>
                        <Grid2 md={7} xs={12} >
                            <label className="form-label text-form-title mt-2"
                            >شماره کارت</label>
                            <TextField
                                value={accountNumber}
                                onChange={(event) => {setAccountNumber(event.target.value); setAccountNumberError(false)} }
                                 fullWidth size="small" placeholder="شماره کارت خود را وارد کنید"/>
                            {accountNumberError && <InputError message={'شماره کارت وارد شده صحیح نیست'} show={accountNumberError} />}
                        </Grid2>
                        <Grid2 md={7} xs={12} >
                            <label className="form-label text-form-title mt-3"
                            >شماره شبا</label>
                            <TextField
                                value={shebaNumber}
                                onChange={(event) => {setShebaNumber(event.target.value); setShebaNumberError(false)} }
                                fullWidth size="small" placeholder="شماره شبا خود را وارد کنید"/>
                            {shebaNumberError && <InputError message={'شماره شبا وارد شده صحیح نیست'} show={shebaNumberError} />}
                        </Grid2>
                        <Grid2 md={7} xs={12} >
                            <label className="form-label text-form-title mt-3"
                            >دلیل انصراف</label>
                            <TextField
                                value={cancelReason}
                                onChange={(event) => {setCancelReason(event.target.value);} }
                                fullWidth size="small" placeholder="لطفا دلیل انصراف خود را بنویسید"/>
                        </Grid2>
                        <Grid2 md={7} xs={12} textAlign="center">
                            <div className='text-center d-flex mt-3'>
                                <button
                                    className='btn border text-form-title ms-2 w-100'
                                    style={{"padding": "1.5% 13%"}}
                                    onClick={() => setOpenModal(false)}
                                >بستن
                                </button>

                                <button
                                    className='btn text-form-button me-2 w-100'
                                    style={{"background": "#044448", "padding": "1.5% 13%"}}
                                    onClick={handleCancel}
                                    disabled={isModalLoading}
                                >ادامه
                                </button>
                            </div>

                        </Grid2>
                    </Grid2>
                </DialogContent>

            </Dialog>

            <FormProvider {...methods}>
                <form
                    onSubmit={e => e.preventDefault()}
                    noValidate
                    className="container"
                >

                    <Input
                        lable_text="نام ثبتی سازمان/شرکت/موسسه"
                        type="text"
                        name="companyName"
                        placeholder="نام ثبت شده"
                        hasError={companyInfoError?.companyNameError ? 'error' : 'correct'}
                        validation={{
                            required: {
                                value: true,
                                message: 'نام ثبت شده برای سازمان/شرکت/موسسه خود را وارد کنید',
                            },
                        }}
                        readOnly={disable}
                    />

                    <Input
                        lable_text="شناسه ملی سازمان/شرکت/موسسه"
                        readOnly={disable}
                        type="text"
                        name="companyNationalId"
                        hasError={companyInfoError?.companyNationalIdError ? 'error' : 'correct'}
                        placeholder="شناسه ملی ثبت شده"
                        validation={{
                            required: {
                                value: true,
                                message: 'شناسه ملی سازمان/شرکت/موسسه خود را وارد کنید',
                            },
                        }}
                        tooltip_title={'جهت دریافت این شناسه، به پایگاه اطلاع‌رسانی شناسه ملی اشخاص حقوقی کشور به آدرس www.ilenc.ir مراجعه نمایید.'}
                    />

                    <SelectOption
                        // defaultValue={companyInfo?.companyType}
                        lable_text={'نوع سازمان/شرکت/موسسه'}
                        disbale={disable}
                        optionList={[
                            {value: 'Governmental', label: 'دولتی'},
                            {value: 'Non-Governmental', label: 'غیر دولتی'}
                        ]}
                        hasError={companyInfoError?.companyTypeError ? 'error' : 'correct'}
                        name={'companyType'}
                        errorMessage={'نوع سازمان خود را انتخاب کنید'}
                    />

                    <CitySelect
                        control={methods.control}
                        disable={disable}
                        watch={methods.watch}
                        hasError={companyInfoError?.addressError ? 'error' : 'correct'}
                    />

                    <TextArea
                        lable_text="آدرس محل اقامت"
                        type="text"
                        disable={disable}
                        name="address"
                        hasError={companyInfoError?.addressError ? 'error' : 'correct'}
                        placeholder="آدرس محل اقامت خود را وارد کنید"
                        validation={{
                            required: {
                                value: true,
                                message: 'آدرس محل اقامت خود را وارد کنید',
                            },
                        }}
                    />


                    <Input
                        lable_text="شماره تلفن"
                        readOnly={disable}
                        type="text"
                        name="phoneNumber"
                        hasError={companyInfoError?.phoneNumberError ? 'error' : 'correct'}
                        placeholder="شماره تلفن سازمان"
                        validation={{
                            required: {
                                value: true,
                                message: 'شماره تلفن سازمان/شرکت/موسسه خود را وارد کنید',
                            },
                        }}
                    />

                    <Input
                        lable_text="نام ثبتی سازمان/شرکت/موسسه (انگلیسی)"
                        hasError={companyInfoError?.latinCompanyNameError ? 'error' : 'correct'}
                        type="text"
                        readOnly={disable}
                        name="latinCompanyName"
                        placeholder="نام ثبت شده"
                        validation={{
                            required: {
                                value: true,
                                message: 'نام ثبت شده برای سازمان/شرکت/موسسه خود را وارد کنید',
                            },
                        }}
                    />

                    <UploadFile
                        label_text={'تصویر معرفی نامه '}
                        disable={disable}
                        name={'introductionLetterImage'}
                        formData={formData}
                        valueName={companyInfo?.introductionLetterImage}
                        hasError={companyInfoError?.introductionLetterImageError ? 'error' : 'correct'}
                        href={require('../../../form_ex/present.pdf')}
                        fileName={'moarfi_name_ex.pdf'}
                    />

                    <UploadFile
                        label_text={'تصویر آخرین تغییرات شرکت (روزنامه رسمی)'}
                        disable={disable}
                        name={'latestOfficialNewspaperImage'}
                        hasError={companyInfoError?.latestOfficialNewspaperImageError ? 'error' : 'correct'}
                        formData={formData}
                        valueName={companyInfo?.latestOfficialNewspaperImage}
                    />

                    <UploadFile
                        label_text={'تصویر روی کارت ملی مدیر عامل'}
                        disable={disable}
                        name={'managerNationalCardImage'}
                        hasError={companyInfoError?.managerNationalCardImageError ? 'error' : 'correct'}
                        formData={formData}
                        valueName={companyInfo?.managerNationalCardImage}
                    />

                    <UploadFile
                        label_text={'تصویر آگهی تاسیس شرکت (روزنامه رسمی)'}
                        disable={disable}
                        name={'establishedNewspaperImage'}
                        formData={formData}
                        hasError={companyInfoError?.establishedNewspaperImageError ? 'error' : 'correct'}
                        valueName={companyInfo?.establishedNewspaperImage}
                    />

                    <div className='row justify-content-center my-3 mt-5'>

                        <div className='col-12 col-md-5 d-flex justify-content-between'>
                            <button
                                className='btn border text-form-title ms-2'
                                style={{"padding": "1.5% 17%"}}
                                onClick={() => dispatch(prevStep())}
                            >بازگشت
                            </button>

                            <button
                                onClick={onSubmit}
                                className='btn text-form-button me-2'
                                style={{"background": "#044448", "padding": "1% 17%"}}
                            >ادامه
                            </button>
                        </div>
                    </div>

                    {!disable && <div className='row justify-content-center my-3'>

                        <div className='col-12 col-md-5 text-center cancel-text pointer'
                             onClick={() => setOpenModal(true)}
                        >
                            انصراف از دریافت گواهی
                        </div>
                    </div>}

                </form>
            </FormProvider>
            {isSubmitted && (
                <div className="loading-overlay">
                    <div className="loading-content">
                        <div className="spinner"></div>
                        <p className='loader-text mt-3'>لطفا چند لحظه منتظر بمانید</p>
                    </div>
                </div>
            )}
        </div>
    )
}

         